import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpParams,
} from '@angular/common/http';
import { EMPTY, Observable } from 'rxjs';
import { AuthService } from '../core/authentication/authentication.servicie';

@Injectable()
export class TokenInterceptor implements HttpInterceptor {


    constructor(private authService:AuthService){}

  private cache: any = [];

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    let token = this.authService.token
    const cacheKey = req.urlWithParams;
    const staticArr = [/\/getStringsJson/, /\/getRequestedLanguages/];
    if (token &&staticArr.some(regex => regex.test(cacheKey))) {
        const authReq = req.clone({
          setHeaders: { Authorization: `${token}` },
        });
        return next.handle(authReq);
      }
  
      return next.handle(req);
  }
}


@Injectable()
export class RemoveNullParamsInterceptor implements HttpInterceptor {
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    let updatedParams = new HttpParams();

    req.params.keys().forEach((key) => {
      const value = req.params.get(key);

      // Skip parameters with null value or "null" string for cityId / agencyId
      if (
        value !== null &&
        value !== 'null' &&
        !(
          (key.toLowerCase().includes('cityid') || key.toLowerCase().includes('agencyid')) &&
          value === 'null'
        )
      ) {
        updatedParams = updatedParams.set(key, value);
      }
    });

    const modifiedReq = req.clone({ params: updatedParams });

    return next.handle(modifiedReq);
  }
}